import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { getLoginAccessToken } from '../services/auth-details-service';
import HooperLoading from '../components/cp-spinners/cp-spinner';

function ProtectedRoute({ component: Component, path }) {
  const isLoggedIn = getLoginAccessToken();
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldRender(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {!shouldRender ? (
        <div className="spin">
          <HooperLoading />
        </div>

      ) : (
        <Route
          path={path}
          render={(props) => {
            if (shouldRender) {
              if (isLoggedIn) {
                return <Component {...props} />;
                // eslint-disable-next-line no-else-return
              } else {
                return <Redirect to="/" />;
              }
              // eslint-disable-next-line no-else-return
            } else {
              // Render a loading indicator or null during the delay
              return null;
            }
          }}
        />
      )}
    </>
  );
}

ProtectedRoute.propTypes = {
  component: PropTypes.any.isRequired,
  path: PropTypes.string.isRequired,
};

export default ProtectedRoute;
